export const PMS_TYPES = [
    { value: 'NONE', label: 'None' },
    { value: 'OD_OFFICE', label: 'OD Office' },
    { value: 'IFILE', label: 'iFile' },
    { value: 'OPTOSYS', label: 'Optosys' },
    { value: 'OTHER', label: 'Other' },
];

export const formatPmsType = (value) => {
    if (!value) {
        return 'None';
    }
    return PMS_TYPES.find((type) => type.value === value)?.label || value;
};
